// extracted by mini-css-extract-plugin
export default {"host":"style_host__irmLD","slider":"style_slider__xi7ZL","add":"style_add__RixuA","form":"style_form__Nycgt","activity":"style_activity__brAxH","checkbox":"style_checkbox__eX3y1"};